import { PropsWithChildren } from 'react';

import { Alert } from '@twilio-paste/core/alert';

export const ViewErrorState = ({ children }: PropsWithChildren) => (
  <Alert variant="error">{children || 'Failed to retrieve data. Please try again later.'}</Alert>
);
